import { Countries } from '@/utils/common';

import { COUNTRY_CHL } from './countries';

/**
 * Países habilitados para la integración con Falabella
 */
export const FALABELLA_ENABLED_COUNTRIES: Countries[] = [COUNTRY_CHL];

/**
 * Helper para verificar si un país tiene habilitado Falabella
 */
export const isFalabellaEnabledCountry = (country?: Countries | string | null): boolean => {
  if (!country) return false;
  return FALABELLA_ENABLED_COUNTRIES.includes(country as Countries);
};
